import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const WishlistContext = createContext(null);
const STORAGE_KEY = "noteconsole_wishlist_v1";

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }, [ids]);

  const has = (id) => ids.includes(id);

  const toggle = (product) => {
    setIds((prev) => {
      if (prev.includes(product.id)) {
        toast.success(`${product.name} removed from wishlist`);
        return prev.filter((x) => x !== product.id);
      }
      toast.success(`${product.name} saved to wishlist`);
      return [...prev, product.id];
    });
  };

  const remove = (id) => setIds((prev) => prev.filter((x) => x !== id));
  const clear = () => setIds([]);

  const count = useMemo(() => ids.length, [ids]);

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, remove, clear, count }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
